import Icon from 'components/shared/Icon/Icon';

const OrganizationCard = ({ organization }) => {
  if (!organization) return null;

  const address = [
    organization.address_line_1,
    organization.city,
    organization.state,
    organization.zip
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <div className="flex flex-col gap-6 rounded-md border border-solid border-neutral-200 p-5">
      <p className="text-sm font-400 text-neutral-600">You are part of this organization:</p>
      <div className="flex items-center justify-between sm:flex-col sm:items-start sm:gap-6">
        <div className="flex gap-3">
          <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-md border border-solid border-neutral-200 bg-white p-2">
            <Icon icon="practice-mono" size={32} color="neutral" />
          </div>
          <div className="flex flex-col">
            <h6 className="text-base font-600 text-neutral-800">
              {organization.displayName || organization.name}
            </h6>
            <p className="text-sm font-400 text-neutral-600">{address || '-'}</p>
          </div>
        </div>

        <div className="mr-10 flex items-center gap-10">
          <div className="flex flex-col gap-1">
            <label className="text-sm text-neutral-600">ID</label>
            <p className="text-sm font-500 text-neutral-800">{organization.id}</p>
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm text-neutral-600">Owner</label>
            <p className="text-sm font-500 text-neutral-800">{organization.owner_name || 'N/A'}</p>
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm text-neutral-600">Phone number</label>
            <p className="text-sm font-500 text-neutral-800">{organization.phone || 'N/A'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationCard;
